import React from 'react';

import CasinoIcon from '@swf/core/assets/sideMenu/casino.svg';
import ChipIcon from '@swf/core/assets/sideMenu/chip.svg';
import HomeGamesIcon from '@swf/core/assets/sideMenu/home-games.svg';
import HomeIcon from '@swf/core/assets/sideMenu/home.svg';
import LiveEventsIcon from '@swf/core/assets/sideMenu/live-events.svg';
import PokerCardsIcon from '@swf/core/assets/sideMenu/poker-cards.svg';
import ResponsibleGamingIcon from '@swf/core/assets/sideMenu/responsible-gaming.svg';
import RocketIcon from '@swf/core/assets/sideMenu/rocket.svg';
import SportsIcon from '@swf/core/assets/sideMenu/sport.svg';

interface Props {
  icon?: string;
  className?: string;
}

const Icon: React.FC<Props> = ({ icon, className }) => {
  switch (icon) {
    case 'Poker':
      return <PokerCardsIcon className={className} />;
    case 'Casino':
      return <CasinoIcon className={className} />;
    case 'Sports':
      return <SportsIcon className={className} />;
    case 'Rocket':
      return <RocketIcon className={className} />;
    case 'HomeGames':
      return <HomeGamesIcon className={className} />;
    case 'Seasons':
      return <ChipIcon className={className} />;
    case 'Home':
      return <HomeIcon className={className} />;
    case 'LiveEvents':
      return <LiveEventsIcon className={className} />;
    case 'ResponsibleGaming':
      return <ResponsibleGamingIcon className={className} />;
    default:
      return null;
  }
};

export default Icon;
